// 物料信息-详情
import { useEffect, useReducer, useState } from 'react'
import type { FocusEvent as ReactFocusEvent } from 'react'
import { Button, Form, Skeleton, Space, Divider, message, Spin } from 'antd'
import moment from 'moment'
import Maininfo from '../../modules/goodsdetailmodules/maininfo'
import Expandattr from '../../modules/goodsdetailmodules/expandattr'
import Uploadimg from '../../modules/goodsdetailmodules/uploadimg'
import AptitudeAttach from '../../modules/goodsdetailmodules/AptitudeAttach'
import Style from './goodsmanage.module.scss'
// import { GET_PRODUCT_DETAIL } from '../../api/MaterialApi'
import {
  GET_PROJECT_FIELD_BY_PLATFORM_CODE,
  GET_REPORT_MATERIAL_DETAIL,
  MaterialReportDetailVO,
  POST_GET_STORAGE_NEW_MATERIAL,
  ReportFieldValueSubmitDTO,
} from '@/api/reportApi'
import { GET_CODEPRODUCT_DETAIL } from '@/api/MaterialApi'
import { GET_CATEGORY_FRONTEND_HINT_TEXT } from '@/api/categoryQualificationApi'
import { history, useTypedSelector } from '../../redux/store'
import { useDispatch } from 'react-redux'
import {
  setformStateInitAction,
  setformStateAction,
} from '../../modules/ControlformState'
import { useLocation } from 'react-router-dom'
import { setModuleDataAction } from '../../modules/pagecache'
import useHook, {
  setRouterParams,
  setProjectCodeAction,
  setExtendedInfoListAction,
} from './hook'
import { StorageDraft, pickSupplierFilledDraft } from './storageDraft'
import Originalpic from '../../modules/goodsdetailmodules/originalpic'
import { RoleType, isResponseCodeSuccess } from '../../tools/util'
import Mainpic from '../../modules/goodsdetailmodules/mainpic'
import Secondaryinfo from '../../modules/goodsdetailmodules/secondaryinfo'
import ExternalLink, {
  ExternalLinkType,
} from '@/modules/goodsdetailmodules/externallink'
import PersentHeaderDetail from '@/modules/goodsdetailmodules/persentHeaderDetail'
import GoodsSubmissionInfo from '@/modules/goodsdetailmodules/goodsSubmissionInfo.tsx'
import { reportTypeEnum } from '@/global/enum/product'
import ProjectValidationInfo from './ProjectValidationInfo'

const ACTION_TYPE = {
  SET_CURRENT_PARAM: 'set_current_param', // 设置当前页面参数
  CHANGE_DATA: 'CHANGE_DATA', // 替换所有状态
  SET_SHOW_RATE: 'SET_SHOW_RATE', // 设置折扣展示
}
interface State {
  currentparam: nowpagesparam // 当前参数
}
interface nowpagesparam {
  id: string
  BtnState: MaterialDetailType[] // 模块状态
}
export interface treeType {
  id: string // 树 id
  title: string // 树名称
  level: string // 树层级
  parentId?: string // 父级id
}
export const defaultState: State = {
  currentparam: {
    id: '',
    BtnState: [],
  },
}
const reducer = (state: State, action: { type: string; value?: any }) => {
  let arr = { ...state }
  switch (action.type) {
    case ACTION_TYPE.SET_CURRENT_PARAM:
      arr.currentparam = action.value
      return arr
    case ACTION_TYPE.CHANGE_DATA:
      arr = action.value
      return arr

    default:
      return { ...state }
  }
}

// 重新加载数据
const reloadDataAction = (params: State) => ({
  type: ACTION_TYPE.CHANGE_DATA,
  value: params,
})

// 路由参数
interface RouteParam extends nowpagesparam {
  init?: boolean // 是否初始化
  copydata?: any // copy
  isSingleSubmission?: boolean // 是否为单条提报
  platformCode?: string // 平台编码
  platformName?: string // 平台名称
  productCode?: string // 商品编码
  submissionType?: string // 提报类型
  showDiscountRate?: '1' | '0' // 折扣展示
}
const formItemLayout = {
  labelCol: { span: 10 },
  wrapperCol: { span: 14 },
}

// 从暂存 JSON 反序列化表单值（把被包装的 moment 字段还原）
const deserializeStoredFormValues = (values: Record<string, any>) => {
  const result: Record<string, any> = {}
  Object.keys(values || {}).forEach((key) => {
    const value = values[key]
    if (
      value &&
      typeof value === 'object' &&
      value.__type === 'moment' &&
      value.value
    ) {
      result[key] = moment(value.value)
    } else if (Array.isArray(value)) {
      result[key] = value.map((item) =>
        item &&
        typeof item === 'object' &&
        item.__type === 'moment' &&
        item.value
          ? moment(item.value)
          : item,
      )
    } else {
      result[key] = value
    }
  })
  return result
}
// 移除未使用的 itemLayou 变量
const Goodsdetail = () => {
  const {
    usehookstate,
    form,
    dispatchhook,
    platform_form,
    onChangePic,
    onChangeAptitude,
    onChangeDetailPic,
    onChangeCate,
    // onChangeBrandSale,
    onClickClose,
    // onCancelrecord,
    onChangeLoading,
    reloaddata,
    tempCode,
    onChangeDelivery,
    // setMaterialType,
    formatFormFields,
    // changeItemList,
    onFieldsChange,
    externalLinkList,
    setExternalLinkList,
    onSave,
    onSaveAndSumbit,
    setQualityDataList,
    onStorage,
    preCheckErrors,
    setReportFieldConfigList,
    PreCheckModalComponent,
    relateFieldKeySet,
    handleRelateFieldBlur,
    relateFieldCalcLoading,
    submitting,
  } = useHook()
  const [pagesstate, dispatch] = useReducer(reducer, defaultState)
  const [savedReportFieldValues, setSavedReportFieldValues] = useState<
    ReportFieldValueSubmitDTO[]
  >([])
  const dispatchRedux = useDispatch()
  const {
    pictures,
    qualDocFileList,
    frontendHintText,
    detailPic,
    productCode,
    fieldList,
    // isRecord,
    loadingPage,
    hasDelivery,
    // unitDisabled,
    // materialType,
    itemsList,
    routerParams,
    extendedInfoList,
    projectCode,
    qualityDataList,
  } = usehookstate
  const { role } = useTypedSelector((state) => state.authtoken)
  const { pagekey } = useTypedSelector((state) => state.pageCache)
  const location = useLocation<RouteParam>()
  const { state } = location
  useEffect(() => {
    const flag = getpagecache()
    if (flag && !state) {
      // 读取缓存的公共模块状态
      reloaddata(flag.commonState)
      // 确保从缓存恢复后关闭loading状态
      onChangeLoading(false)
      // 设置form数据
      form.setFieldsValue(flag.formState)
      // 读取缓存的当前模块状态
      dispatch(reloadDataAction(flag.pageState))
      // 判断物料属性
      materialattrDisabled(flag.pageState.currentparam.BtnState)
    } else if (state) {
      dispatchhook(setRouterParams(state))
      dispatchRedux(setformStateInitAction())
      materialattrDisabled(state.BtnState)
      getProductInfo(state)
      // form.setFieldsValue({ childId: state.childId }) // 设置物料id 如果为新增则是空 用于maininfo页面判断
    }
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    // 缓存存数据
    const pathName = history.location.pathname + 'goodsSubmission'
    const formstate = form.getFieldsValue()
    const action = setModuleDataAction({
      key: pathName,
      data: {
        commonState: usehookstate, // 公共状态
        pageState: pagesstate, // 当前状态
        formState: formstate,
      },
    })
    dispatchRedux(action)
    return () => {
      const formstate = form.getFieldsValue()
      const action = setModuleDataAction({
        key: pathName,
        data: {
          commonState: usehookstate, // 公共状态
          pageState: pagesstate, // 当前状态
          formState: formstate,
        },
      })
      dispatchRedux(action)
    }
    // eslint-disable-next-line
  }, [usehookstate, pagesstate])

  console.log(routerParams, 'routerParams')

  const handleLinkChange = (newList: ExternalLinkType[]) => {
    setExternalLinkList(newList)
  }

  // 编辑获取数据
  const getProductInfo = async (state: RouteParam) => {
    try {
      onChangeLoading(true)
      let res: any
      // 暂存草稿不再直接回显：主数据照常走实时链路，草稿只在最后回填供应商填报的那部分
      let draft: StorageDraft | null = null
      if (state.isSingleSubmission) {
        if (state.submissionType === 'NEW') {
          const _res = await POST_GET_STORAGE_NEW_MATERIAL({
            projectCode: state.platformCode,
            materialCode: state.productCode,
          })

          if (_res.code === 0) {
            const storageInfoJson = _res.data?.storageInfoJson
            if (storageInfoJson) {
              draft = JSON.parse(storageInfoJson)
            }
          } else {
            message.error(_res.msg)
          }
        }

        const promiseArr = [
          GET_PROJECT_FIELD_BY_PLATFORM_CODE({
            platformCode: state.platformCode || '',
            submitOperateType: state.submissionType || '',
            productCode: state.productCode || '',
          }),
          GET_CODEPRODUCT_DETAIL({
            platformCode: state.platformCode || '',
            code: state.productCode || '',
          }),
        ]

        const [platformData, productDetailData] = await Promise.all(promiseArr)

        const projectField = platformData.data
        const productDetail = productDetailData.data
        // 主数据取不到就报错收场，不退回只用暂存值渲染
        if (!isResponseCodeSuccess(productDetailData.code) || !productDetail) {
          message.error(productDetailData.msg || '获取物料信息失败，请稍后重试')
          return
        }
        setQualityDataList(productDetail.materialAptitudeFileList)
        res = {
          code: 0,
          data: {
            productDetailJson: JSON.stringify(productDetail),
            extendedInfoList: projectField,
            projectCode: state.platformCode,
            projectName: state.platformName,
            materialCode: productDetail.code,
            materialName: productDetail.name,
            materialAptitudeFileList: productDetail.materialAptitudeFileList,
            qualDocFileList: productDetail.qualDocFileList,
            reportFieldValues: productDetail.reportFieldValues || [],
          },
        }
      } else {
        res = await GET_REPORT_MATERIAL_DETAIL(state.id)
      }
      if (res && isResponseCodeSuccess(res.code)) {
        dispatchhook(setProjectCodeAction(res.data.projectCode))
        dispatchhook(setExtendedInfoListAction(res.data.extendedInfoList))

        // 提取已保存的提报动态字段值，传递给 ProjectValidationInfo 进行回显
        setSavedReportFieldValues(res.data.reportFieldValues || [])

        const {
          reportCode,
          projectName,
          materialCode,
          materialName,
          reportStatusName,
          reportTime,
          auditUserName,
          auditTime,
          auditRemark,
          materialAptitudeFileList,
        } = res.data
        setQualityDataList(materialAptitudeFileList)
        // 商品提报信息赋值
        form.setFieldsValue({
          reportCode,
          projectName,
          materialCode,
          materialName,
          reportStatusName,
          reportTime,
          auditUserName,
          auditTime,
          auditRemark,
        })

        // 商品详情赋值
        const detailData = JSON.parse(res.data.productDetailJson)
        await onChangeCate(detailData.fourthCateMdmId, undefined, undefined, '')
        const formatData = formatFormFields(detailData)
        // 资料附件（12 类 docType 资质）回显：后端返 qualDocFileList
        onChangeAptitude(res.data.qualDocFileList || [])
        form.setFieldsValue(formatData)
        form.setFieldsValue({
          saleJobNumber: res.data.saleJobNumber,
          saleName: res.data.saleName,
          saleRemark: res.data.saleRemark,
        })
        const newExternalLinks = detailData.externalLinks.map((item: any) => {
          return {
            ...item,
            externalFile: item.externalFile
              ? JSON.parse(item.externalFile)
              : [],
          }
        })

        setExternalLinkList(newExternalLinks)
        applyStorageDraft(draft)
      }
    } catch (error) {
      console.error('获取产品信息失败:', error)
      message.error('获取物料信息失败，请稍后重试')
    } finally {
      onChangeLoading(false)
    }
  }

  // 草稿只回填供应商填报的部分，主数据用上面刚取到的实时值，取舍规则见 storageDraft.ts
  const applyStorageDraft = (storageDraft: StorageDraft | null) => {
    const draft = pickSupplierFilledDraft(storageDraft)
    if (!draft) {
      return
    }
    form.setFieldsValue(draft.formValues)
    platform_form.setFieldsValue(
      deserializeStoredFormValues(draft.platformFormValues),
    )
    if (draft.qualityDataList) {
      setQualityDataList(draft.qualityDataList)
    }
  }

  // 获取数据
  const getpagecache = () => {
    const pathName = history.location.pathname + 'goodsSubmission'
    const data = pagekey.filter((item) => item.key === pathName)
    if (data.length === 1) {
      return data[0].data
    }
    return null
  }

  // 物料属性是否可修改
  const materialattrDisabled = (params?: MaterialDetailType[]) => {
    let flag = false
    if (role === RoleType.SOURCE_PURCHASE_MAN && params) {
      // 采购员 物料属性
      flag = true
    }
    dispatchRedux(setformStateAction([{ key: 'materialattr', disabled: flag }]))
  }
  const isDetail = (state?.BtnState || routerParams?.BtnState || [])?.includes(
    'Detail',
  )
  // 只读分区的遮罩只有 pointer-events:none，挡不住键盘 Tab 进去改主数据；
  // 聚焦即失焦来补，标签文本不可聚焦故不影响选中复制
  const blockFocus = (e: ReactFocusEvent) => {
    ;(e.target as HTMLElement).blur?.()
  }
  // 按钮类型
  const ButtonComponents = () => {
    return (
      <div className={Style.btnbox}>
        <div className={Style['btn-left-box']}></div>
        <div className={Style['btn-center-box']}></div>
        <div className={Style['btn-right-box']}>
          <Space>
            {routerParams.isSingleSubmission ? (
              <>
                {/* 新增提报 暂存功能 */}
                <Button
                  type="link"
                  size="small"
                  hidden={routerParams.submissionType !== 'NEW'}
                  disabled={submitting}
                  onClick={() => onStorage()}
                >
                  保存
                </Button>

                <Button
                  type="link"
                  size="small"
                  loading={submitting}
                  onClick={() => onSaveAndSumbit()}
                >
                  保存并提交
                </Button>
              </>
            ) : (
              <>
                {!isDetail && (
                  <Button
                    type="link"
                    size="small"
                    disabled={submitting}
                    onClick={() => onSave('save')}
                  >
                    保存
                  </Button>
                )}
                {!isDetail && (
                  <Button
                    type="link"
                    size="small"
                    loading={submitting}
                    onClick={() => onSave('submit')}
                  >
                    保存并提交
                  </Button>
                )}
              </>
            )}
            <Button type="link" size="small" onClick={onClickClose}>
              关闭
            </Button>
          </Space>
        </div>
      </div>
    )
  }

  return (
    <Form.Provider>
      <div>
        <PersentHeaderDetail
          form={form}
          isSingleSubmission={routerParams.isSingleSubmission}
        />
        <ButtonComponents />
      </div>
      <div
        className={Style.container}
        style={{ height: 'calc(100vh - 258px)' }}
      >
        {/* 提报信息 可编辑 */}
        <div>
          <div className={Style.box}>
            <div className={Style.boxtitle}>
              <span>
                {reportTypeEnum.isLabelsMatchValue(
                  ['商品新增'],
                  routerParams.submissionType,
                )
                  ? '提报商品信息'
                  : reportTypeEnum.getLabelByValue(routerParams.submissionType)}
              </span>
            </div>
            <Divider style={{ margin: '0' }} />
            <Skeleton loading={loadingPage} active>
              <Form
                {...formItemLayout}
                form={platform_form}
                colon={true}
                labelAlign="right"
                style={{ margin: '10px 0 0 0', padding: '0 10px 0 10px' }}
                size="small"
                onFieldsChange={onFieldsChange}
              >
                <GoodsSubmissionInfo
                  normalForm={form}
                  isShowSaleInfo={reportTypeEnum.isLabelsMatchValue(
                    ['商品新增'],
                    routerParams.submissionType,
                  )}
                  submissionType={routerParams.submissionType}
                  projectCode={projectCode}
                  extendedInfoList={extendedInfoList}
                  form={platform_form}
                  qualityDataList={qualityDataList}
                  setQualityDataListAction={setQualityDataList}
                  preCheckErrors={preCheckErrors}
                  showRate={routerParams?.showDiscountRate ?? '0'}
                  relateFieldKeySet={relateFieldKeySet}
                  onRelateFieldBlur={handleRelateFieldBlur}
                  validationInfo={
                    <ProjectValidationInfo
                      platformCode={projectCode}
                      reportingType={routerParams.submissionType || ''}
                      form={platform_form}
                      onConfigChange={setReportFieldConfigList}
                      reportFieldValues={savedReportFieldValues}
                    />
                  }
                />
              </Form>
            </Skeleton>
          </div>
          {isDetail && <div className={Style.mask} />}
        </div>
        {/* 项目校验信息 */}

        {/* <div className={Style.box}>
          <div className={Style.boxtitle}>
            <span>项目展示信息</span>
          </div>
          <Divider style={{ margin: '0' }} />
          <Skeleton loading={loadingPage} active>
            <Spin spinning={relateFieldCalcLoading}>
              <ProjectValidationInfo
                platformCode={projectCode}
                reportingType={routerParams.submissionType || ''}
                form={platform_form}
                onConfigChange={setReportFieldConfigList}
              />
            </Spin>
          </Skeleton>
        </div> */}

        {/* 主要信息 只读 */}
        <div className={Style.maskWrapper} onFocusCapture={blockFocus}>
          <div className={Style.box}>
            <div className={Style.boxtitle}>
              <span>主要信息</span>
            </div>
            <Divider style={{ margin: '0' }} />
            <Skeleton loading={loadingPage} active>
              <Maininfo
                form={form}
                onFieldsChange={onFieldsChange}
                preCheckErrors={preCheckErrors}
              />
            </Skeleton>
          </div>
          <div className={Style.mask} />
        </div>

        {/* 次要信息 只读 */}
        <div className={Style.maskWrapper} onFocusCapture={blockFocus}>
          <div className={Style.box}>
            <div className={Style.boxtitle}>
              <span>次要信息</span>
            </div>
            <Divider style={{ margin: '0' }} />
            <Skeleton loading={loadingPage} active>
              <Secondaryinfo
                form={form}
                onFieldsChange={onFieldsChange}
                onChangeDelivery={onChangeDelivery}
                hasDelivery={hasDelivery}
              />
            </Skeleton>
          </div>
          <div className={Style.mask} />
        </div>

        {/* 拓展属性 只读 */}
        <div className={Style.maskWrapper} onFocusCapture={blockFocus}>
          <div className={Style.box}>
            <div className={Style.boxtitle}>
              <span>拓展属性</span>
              <span className={Style.tips}>
                拓展属性标题为<span className={Style.blueTip}>蓝色</span>
                代表有平台项目对该拓展属性有要求，鼠标移到拓展属性标题即可查看具体平台项目。
                <span
                  style={{
                    color: '#8C8C8C',
                    fontSize: '12px',
                    lineHeight: '24px',
                  }}
                >
                  都需填写，无法填写的填/【如果是大批量无法填写，可能是四级类目选错】
                </span>
              </span>
            </div>
            <Divider style={{ margin: '0' }} />
            <Skeleton loading={loadingPage} active>
              <Expandattr
                form={form}
                onFieldsChange={onFieldsChange}
                fieldList={fieldList}
                itemsList={itemsList}
                frontendHintText={frontendHintText}
              />
            </Skeleton>
          </div>
          <div className={Style.mask} />
        </div>

        <div className={Style.maskWrapper} onFocusCapture={blockFocus}>
          <div className={Style.box}>
            <Divider style={{ margin: '0' }} />
            <AptitudeAttach
              dataSource={qualDocFileList}
              onChange={onChangeAptitude}
              productCode={productCode}
              loading={loadingPage}
            />
          </div>
          <div className={Style.mask} />
        </div>

        {/* 外部链接/价格佐证 只读 */}
        <div className={Style.maskWrapper} onFocusCapture={blockFocus}>
          <div className={Style.box}>
            <div className={Style.boxtitle}>
              <span>外部链接/价格佐证</span>
            </div>
            <Divider style={{ margin: '0' }} />
            <Skeleton loading={loadingPage} active>
              <ExternalLink
                form={form}
                externalLinkList={externalLinkList}
                onLinkChange={handleLinkChange}
              />
            </Skeleton>
          </div>
          <div className={Style.mask} />
        </div>

        {/* 图文信息 只读 */}
        <div className={Style.maskWrapper} onFocusCapture={blockFocus}>
          <div className={Style.box}>
            <div className={Style.boxtitle}>
              <span>图文信息</span>
            </div>
            <Divider style={{ margin: '0' }} />
            <Skeleton loading={loadingPage} active>
              <div className={Style.picinfobox}>
                {/* true 显示 匹配、类似 注意必填校验 */}
                <Mainpic required form={form} onFieldsChange={onFieldsChange} />
                <div className={Style.picinfotitle}>
                  <span className={Style.text}>
                    主图：
                    <span
                      style={{
                        color: '#8C8C8C',
                        fontSize: '12px',
                        lineHeight: '24px',
                      }}
                    >
                      尺寸：800×800 px。建议上传3张及以上，最多20张。第一张白底，其它尽量白底。主图要求颜色唯一，需要与描述或者拓展属性值一致【最低标准∶不低于在其他平台上架的标准】
                    </span>
                  </span>
                </div>
                {preCheckErrors?.picturesError && (
                  <div
                    style={{
                      color: '#FF7D00',
                      fontSize: '14px',
                      lineHeight: '24px',
                    }}
                  >
                    {preCheckErrors?.picturesError}
                  </div>
                )}
                <Uploadimg
                  dataSource={pictures}
                  onChange={onChangePic}
                  disable
                />
                <div hidden>
                  <Originalpic
                    required={false}
                    form={form}
                    onFieldsChange={onFieldsChange}
                  />
                </div>
                <div className={Style.picinfotitle}>
                  <span className={Style.text}>
                    详情图：
                    <span
                      style={{
                        color: '#8C8C8C',
                        fontSize: '12px',
                        lineHeight: '24px',
                      }}
                    >
                      上传图片宽度不小于500 px，高度不限，最多100张。要图文丰富，需包含产品图、细节图、参数图、使用场景图，【最低标准:不低于在其他平台上架的标准】。一定不能包含:7天无理由退换货、送货上门、免费开票、水印、其它店铺信息、质保、包邮、链接、二维码、电话号码......等敏感词汇
                    </span>
                  </span>
                </div>
                {preCheckErrors?.detailsPicturesError && (
                  <div
                    style={{
                      color: '#FF7D00',
                      fontSize: '14px',
                      lineHeight: '24px',
                    }}
                  >
                    {preCheckErrors?.detailsPicturesError}
                  </div>
                )}
                <Uploadimg
                  dataSource={detailPic}
                  onChange={onChangeDetailPic}
                  disable
                />
              </div>
            </Skeleton>
          </div>
          <div className={Style.mask} />
        </div>
      </div>
      {/* 预审弹框 */}
      {PreCheckModalComponent}
    </Form.Provider>
  )
}

export default Goodsdetail

type MaterialDetailType =
  // 编辑
  | 'Edit'
  // 详情
  | 'Detail'
// 物料信息-详情
import { useEffect, useReducer, useState } from 'react'
import type { FocusEvent as ReactFocusEvent } from 'react'
import { Button, Form, Skeleton, Space, Divider, message, Spin } from 'antd'
import moment from 'moment'
import Maininfo from '../../modules/goodsdetailmodules/maininfo'
import Expandattr from '../../modules/goodsdetailmodules/expandattr'
import Uploadimg from '../../modules/goodsdetailmodules/uploadimg'
import AptitudeAttach from '../../modules/goodsdetailmodules/AptitudeAttach'
import Style from './goodsmanage.module.scss'
// import { GET_PRODUCT_DETAIL } from '../../api/MaterialApi'
import {
  GET_PROJECT_FIELD_BY_PLATFORM_CODE,
  GET_REPORT_MATERIAL_DETAIL,
  MaterialReportDetailVO,
  POST_GET_STORAGE_NEW_MATERIAL,
  ReportFieldValueSubmitDTO,
} from '@/api/reportApi'
import { GET_CODEPRODUCT_DETAIL } from '@/api/MaterialApi'
import { GET_CATEGORY_FRONTEND_HINT_TEXT } from '@/api/categoryQualificationApi'
import { history, useTypedSelector } from '../../redux/store'
import { useDispatch } from 'react-redux'
import {
  setformStateInitAction,
  setformStateAction,
} from '../../modules/ControlformState'
import { useLocation } from 'react-router-dom'
import { setModuleDataAction } from '../../modules/pagecache'
import useHook, {
  setRouterParams,
  setProjectCodeAction,
  setExtendedInfoListAction,
} from './hook'
import { StorageDraft, pickSupplierFilledDraft } from './storageDraft'
import Originalpic from '../../modules/goodsdetailmodules/originalpic'
import { RoleType, isResponseCodeSuccess } from '../../tools/util'
import Mainpic from '../../modules/goodsdetailmodules/mainpic'
import Secondaryinfo from '../../modules/goodsdetailmodules/secondaryinfo'
import ExternalLink, {
  ExternalLinkType,
} from '@/modules/goodsdetailmodules/externallink'
import PersentHeaderDetail from '@/modules/goodsdetailmodules/persentHeaderDetail'
import GoodsSubmissionInfo from '@/modules/goodsdetailmodules/goodsSubmissionInfo.tsx'
import { reportTypeEnum } from '@/global/enum/product'
import ProjectValidationInfo from './ProjectValidationInfo'

const ACTION_TYPE = {
  SET_CURRENT_PARAM: 'set_current_param', // 设置当前页面参数
  CHANGE_DATA: 'CHANGE_DATA', // 替换所有状态
  SET_SHOW_RATE: 'SET_SHOW_RATE', // 设置折扣展示
}
interface State {
  currentparam: nowpagesparam // 当前参数
}
interface nowpagesparam {
  id: string
  BtnState: MaterialDetailType[] // 模块状态
}
export interface treeType {
  id: string // 树 id
  title: string // 树名称
  level: string // 树层级
  parentId?: string // 父级id
}
export const defaultState: State = {
  currentparam: {
    id: '',
    BtnState: [],
  },
}
const reducer = (state: State, action: { type: string; value?: any }) => {
  let arr = { ...state }
  switch (action.type) {
    case ACTION_TYPE.SET_CURRENT_PARAM:
      arr.currentparam = action.value
      return arr
    case ACTION_TYPE.CHANGE_DATA:
      arr = action.value
      return arr

    default:
      return { ...state }
  }
}

// 重新加载数据
const reloadDataAction = (params: State) => ({
  type: ACTION_TYPE.CHANGE_DATA,
  value: params,
})

// 路由参数
interface RouteParam extends nowpagesparam {
  init?: boolean // 是否初始化
  copydata?: any // copy
  isSingleSubmission?: boolean // 是否为单条提报
  platformCode?: string // 平台编码
  platformName?: string // 平台名称
  productCode?: string // 商品编码
  submissionType?: string // 提报类型
  showDiscountRate?: '1' | '0' // 折扣展示
}
const formItemLayout = {
  labelCol: { span: 10 },
  wrapperCol: { span: 14 },
}

// 从暂存 JSON 反序列化表单值（把被包装的 moment 字段还原）
const deserializeStoredFormValues = (values: Record<string, any>) => {
  const result: Record<string, any> = {}
  Object.keys(values || {}).forEach((key) => {
    const value = values[key]
    if (
      value &&
      typeof value === 'object' &&
      value.__type === 'moment' &&
      value.value
    ) {
      result[key] = moment(value.value)
    } else if (Array.isArray(value)) {
      result[key] = value.map((item) =>
        item &&
        typeof item === 'object' &&
        item.__type === 'moment' &&
        item.value
          ? moment(item.value)
          : item,
      )
    } else {
      result[key] = value
    }
  })
  return result
}
// 移除未使用的 itemLayou 变量
const Goodsdetail = () => {
  const {
    usehookstate,
    form,
    dispatchhook,
    platform_form,
    onChangePic,
    onChangeAptitude,
    onChangeDetailPic,
    onChangeCate,
    // onChangeBrandSale,
    onClickClose,
    // onCancelrecord,
    onChangeLoading,
    reloaddata,
    tempCode,
    onChangeDelivery,
    // setMaterialType,
    formatFormFields,
    // changeItemList,
    onFieldsChange,
    externalLinkList,
    setExternalLinkList,
    onSave,
    onSaveAndSumbit,
    setQualityDataList,
    onStorage,
    preCheckErrors,
    setReportFieldConfigList,
    PreCheckModalComponent,
    relateFieldKeySet,
    handleRelateFieldBlur,
    relateFieldCalcLoading,
    submitting,
  } = useHook()
  const [pagesstate, dispatch] = useReducer(reducer, defaultState)
  const [savedReportFieldValues, setSavedReportFieldValues] = useState<
    ReportFieldValueSubmitDTO[]
  >([])
  const dispatchRedux = useDispatch()
  const {
    pictures,
    qualDocFileList,
    frontendHintText,
    detailPic,
    productCode,
    fieldList,
    // isRecord,
    loadingPage,
    hasDelivery,
    // unitDisabled,
    // materialType,
    itemsList,
    routerParams,
    extendedInfoList,
    projectCode,
    qualityDataList,
  } = usehookstate
  const { role } = useTypedSelector((state) => state.authtoken)
  const { pagekey } = useTypedSelector((state) => state.pageCache)
  const location = useLocation<RouteParam>()
  const { state } = location
  useEffect(() => {
    const flag = getpagecache()
    if (flag && !state) {
      // 读取缓存的公共模块状态
      reloaddata(flag.commonState)
      // 确保从缓存恢复后关闭loading状态
      onChangeLoading(false)
      // 设置form数据
      form.setFieldsValue(flag.formState)
      // 读取缓存的当前模块状态
      dispatch(reloadDataAction(flag.pageState))
      // 判断物料属性
      materialattrDisabled(flag.pageState.currentparam.BtnState)
    } else if (state) {
      dispatchhook(setRouterParams(state))
      dispatchRedux(setformStateInitAction())
      materialattrDisabled(state.BtnState)
      getProductInfo(state)
      // form.setFieldsValue({ childId: state.childId }) // 设置物料id 如果为新增则是空 用于maininfo页面判断
    }
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    // 缓存存数据
    const pathName = history.location.pathname + 'goodsSubmission'
    const formstate = form.getFieldsValue()
    const action = setModuleDataAction({
      key: pathName,
      data: {
        commonState: usehookstate, // 公共状态
        pageState: pagesstate, // 当前状态
        formState: formstate,
      },
    })
    dispatchRedux(action)
    return () => {
      const formstate = form.getFieldsValue()
      const action = setModuleDataAction({
        key: pathName,
        data: {
          commonState: usehookstate, // 公共状态
          pageState: pagesstate, // 当前状态
          formState: formstate,
        },
      })
      dispatchRedux(action)
    }
    // eslint-disable-next-line
  }, [usehookstate, pagesstate])

  console.log(routerParams, 'routerParams')

  const handleLinkChange = (newList: ExternalLinkType[]) => {
    setExternalLinkList(newList)
  }

  // 编辑获取数据
  const getProductInfo = async (state: RouteParam) => {
    try {
      onChangeLoading(true)
      let res: any
      // 暂存草稿不再直接回显：主数据照常走实时链路，草稿只在最后回填供应商填报的那部分
      let draft: StorageDraft | null = null
      if (state.isSingleSubmission) {
        if (state.submissionType === 'NEW') {
          const _res = await POST_GET_STORAGE_NEW_MATERIAL({
            projectCode: state.platformCode,
            materialCode: state.productCode,
          })

          if (_res.code === 0) {
            const storageInfoJson = _res.data?.storageInfoJson
            if (storageInfoJson) {
              draft = JSON.parse(storageInfoJson)
            }
          } else {
            message.error(_res.msg)
          }
        }

        const promiseArr = [
          GET_PROJECT_FIELD_BY_PLATFORM_CODE({
            platformCode: state.platformCode || '',
            submitOperateType: state.submissionType || '',
            productCode: state.productCode || '',
          }),
          GET_CODEPRODUCT_DETAIL({
            platformCode: state.platformCode || '',
            code: state.productCode || '',
          }),
        ]

        const [platformData, productDetailData] = await Promise.all(promiseArr)

        const projectField = platformData.data
        const productDetail = productDetailData.data
        // 主数据取不到就报错收场，不退回只用暂存值渲染
        if (!isResponseCodeSuccess(productDetailData.code) || !productDetail) {
          message.error(productDetailData.msg || '获取物料信息失败，请稍后重试')
          return
        }
        setQualityDataList(productDetail.materialAptitudeFileList)
        res = {
          code: 0,
          data: {
            productDetailJson: JSON.stringify(productDetail),
            extendedInfoList: projectField,
            projectCode: state.platformCode,
            projectName: state.platformName,
            materialCode: productDetail.code,
            materialName: productDetail.name,
            materialAptitudeFileList: productDetail.materialAptitudeFileList,
            qualDocFileList: productDetail.qualDocFileList,
            reportFieldValues: productDetail.reportFieldValues || [],
          },
        }
      } else {
        res = await GET_REPORT_MATERIAL_DETAIL(state.id)
      }
      if (res && isResponseCodeSuccess(res.code)) {
        dispatchhook(setProjectCodeAction(res.data.projectCode))
        dispatchhook(setExtendedInfoListAction(res.data.extendedInfoList))

        // 提取已保存的提报动态字段值，传递给 ProjectValidationInfo 进行回显
        setSavedReportFieldValues(res.data.reportFieldValues || [])

        const {
          reportCode,
          projectName,
          materialCode,
          materialName,
          reportStatusName,
          reportTime,
          auditUserName,
          auditTime,
          auditRemark,
          materialAptitudeFileList,
        } = res.data
        setQualityDataList(materialAptitudeFileList)
        // 商品提报信息赋值
        form.setFieldsValue({
          reportCode,
          projectName,
          materialCode,
          materialName,
          reportStatusName,
          reportTime,
          auditUserName,
          auditTime,
          auditRemark,
        })

        // 商品详情赋值
        const detailData = JSON.parse(res.data.productDetailJson)
        await onChangeCate(detailData.fourthCateMdmId, undefined, undefined, '')
        const formatData = formatFormFields(detailData)
        // 资料附件（12 类 docType 资质）回显：后端返 qualDocFileList
        onChangeAptitude(res.data.qualDocFileList || [])
        form.setFieldsValue(formatData)
        form.setFieldsValue({
          saleJobNumber: res.data.saleJobNumber,
          saleName: res.data.saleName,
          saleRemark: res.data.saleRemark,
        })
        const newExternalLinks = detailData.externalLinks.map((item: any) => {
          return {
            ...item,
            externalFile: item.externalFile
              ? JSON.parse(item.externalFile)
              : [],
          }
        })

        setExternalLinkList(newExternalLinks)
        applyStorageDraft(draft)
      }
    } catch (error) {
      console.error('获取产品信息失败:', error)
      message.error('获取物料信息失败，请稍后重试')
    } finally {
      onChangeLoading(false)
    }
  }

  // 草稿只回填供应商填报的部分，主数据用上面刚取到的实时值，取舍规则见 storageDraft.ts
  const applyStorageDraft = (storageDraft: StorageDraft | null) => {
    const draft = pickSupplierFilledDraft(storageDraft)
    if (!draft) {
      return
    }
    form.setFieldsValue(draft.formValues)
    platform_form.setFieldsValue(
      deserializeStoredFormValues(draft.platformFormValues),
    )
    if (draft.qualityDataList) {
      setQualityDataList(draft.qualityDataList)
    }
  }

  // 获取数据
  const getpagecache = () => {
    const pathName = history.location.pathname + 'goodsSubmission'
    const data = pagekey.filter((item) => item.key === pathName)
    if (data.length === 1) {
      return data[0].data
    }
    return null
  }

  // 物料属性是否可修改
  const materialattrDisabled = (params?: MaterialDetailType[]) => {
    let flag = false
    if (role === RoleType.SOURCE_PURCHASE_MAN && params) {
      // 采购员 物料属性
      flag = true
    }
    dispatchRedux(setformStateAction([{ key: 'materialattr', disabled: flag }]))
  }
  const isDetail = (state?.BtnState || routerParams?.BtnState || [])?.includes(
    'Detail',
  )
  // 只读分区的遮罩只有 pointer-events:none，挡不住键盘 Tab 进去改主数据；
  // 聚焦即失焦来补，标签文本不可聚焦故不影响选中复制
  const blockFocus = (e: ReactFocusEvent) => {
    ;(e.target as HTMLElement).blur?.()
  }
  // 按钮类型
  const ButtonComponents = () => {
    return (
      <div className={Style.btnbox}>
        <div className={Style['btn-left-box']}></div>
        <div className={Style['btn-center-box']}></div>
        <div className={Style['btn-right-box']}>
          <Space>
            {routerParams.isSingleSubmission ? (
              <>
                {/* 新增提报 暂存功能 */}
                <Button
                  type="link"
                  size="small"
                  hidden={routerParams.submissionType !== 'NEW'}
                  disabled={submitting}
                  onClick={() => onStorage()}
                >
                  保存
                </Button>

                <Button
                  type="link"
                  size="small"
                  loading={submitting}
                  onClick={() => onSaveAndSumbit()}
                >
                  保存并提交
                </Button>
              </>
            ) : (
              <>
                {!isDetail && (
                  <Button
                    type="link"
                    size="small"
                    disabled={submitting}
                    onClick={() => onSave('save')}
                  >
                    保存
                  </Button>
                )}
                {!isDetail && (
                  <Button
                    type="link"
                    size="small"
                    loading={submitting}
                    onClick={() => onSave('submit')}
                  >
                    保存并提交
                  </Button>
                )}
              </>
            )}
            <Button type="link" size="small" onClick={onClickClose}>
              关闭
            </Button>
          </Space>
        </div>
      </div>
    )
  }

  return (
    <Form.Provider>
      <div>
        <PersentHeaderDetail
          form={form}
          isSingleSubmission={routerParams.isSingleSubmission}
        />
        <ButtonComponents />
      </div>
      <div
        className={Style.container}
        style={{ height: 'calc(100vh - 258px)' }}
      >
        {/* 提报信息 可编辑 */}
        <div>
          <div className={Style.box}>
            <div className={Style.boxtitle}>
              <span>
                {reportTypeEnum.isLabelsMatchValue(
                  ['商品新增'],
                  routerParams.submissionType,
                )
                  ? '提报商品信息'
                  : reportTypeEnum.getLabelByValue(routerParams.submissionType)}
              </span>
            </div>
            <Divider style={{ margin: '0' }} />
            <Skeleton loading={loadingPage} active>
              <Form
                {...formItemLayout}
                form={platform_form}
                colon={true}
                labelAlign="right"
                style={{ margin: '10px 0 0 0', padding: '0 10px 0 10px' }}
                size="small"
                onFieldsChange={onFieldsChange}
              >
                <GoodsSubmissionInfo
                  normalForm={form}
                  isShowSaleInfo={reportTypeEnum.isLabelsMatchValue(
                    ['商品新增'],
                    routerParams.submissionType,
                  )}
                  submissionType={routerParams.submissionType}
                  projectCode={projectCode}
                  extendedInfoList={extendedInfoList}
                  form={platform_form}
                  qualityDataList={qualityDataList}
                  setQualityDataListAction={setQualityDataList}
                  preCheckErrors={preCheckErrors}
                  showRate={routerParams?.showDiscountRate ?? '0'}
                  relateFieldKeySet={relateFieldKeySet}
                  onRelateFieldBlur={handleRelateFieldBlur}
                  validationInfo={
                    <ProjectValidationInfo
                      platformCode={projectCode}
                      reportingType={routerParams.submissionType || ''}
                      form={platform_form}
                      onConfigChange={setReportFieldConfigList}
                      reportFieldValues={savedReportFieldValues}
                    />
                  }
                />
              </Form>
            </Skeleton>
          </div>
          {isDetail && <div className={Style.mask} />}
        </div>
        {/* 项目校验信息 */}

        {/* <div className={Style.box}>
          <div className={Style.boxtitle}>
            <span>项目展示信息</span>
          </div>
          <Divider style={{ margin: '0' }} />
          <Skeleton loading={loadingPage} active>
            <Spin spinning={relateFieldCalcLoading}>
              <ProjectValidationInfo
                platformCode={projectCode}
                reportingType={routerParams.submissionType || ''}
                form={platform_form}
                onConfigChange={setReportFieldConfigList}
              />
            </Spin>
          </Skeleton>
        </div> */}

        {/* 主要信息 只读 */}
        <div className={Style.maskWrapper} onFocusCapture={blockFocus}>
          <div className={Style.box}>
            <div className={Style.boxtitle}>
              <span>主要信息</span>
            </div>
            <Divider style={{ margin: '0' }} />
            <Skeleton loading={loadingPage} active>
              <Maininfo
                form={form}
                onFieldsChange={onFieldsChange}
                preCheckErrors={preCheckErrors}
              />
            </Skeleton>
          </div>
          <div className={Style.mask} />
        </div>

        {/* 次要信息 只读 */}
        <div className={Style.maskWrapper} onFocusCapture={blockFocus}>
          <div className={Style.box}>
            <div className={Style.boxtitle}>
              <span>次要信息</span>
            </div>
            <Divider style={{ margin: '0' }} />
            <Skeleton loading={loadingPage} active>
              <Secondaryinfo
                form={form}
                onFieldsChange={onFieldsChange}
                onChangeDelivery={onChangeDelivery}
                hasDelivery={hasDelivery}
              />
            </Skeleton>
          </div>
          <div className={Style.mask} />
        </div>

        {/* 拓展属性 只读 */}
        <div className={Style.maskWrapper} onFocusCapture={blockFocus}>
          <div className={Style.box}>
            <div className={Style.boxtitle}>
              <span>拓展属性</span>
              <span className={Style.tips}>
                拓展属性标题为<span className={Style.blueTip}>蓝色</span>
                代表有平台项目对该拓展属性有要求，鼠标移到拓展属性标题即可查看具体平台项目。
                <span
                  style={{
                    color: '#8C8C8C',
                    fontSize: '12px',
                    lineHeight: '24px',
                  }}
                >
                  都需填写，无法填写的填/【如果是大批量无法填写，可能是四级类目选错】
                </span>
              </span>
            </div>
            <Divider style={{ margin: '0' }} />
            <Skeleton loading={loadingPage} active>
              <Expandattr
                form={form}
                onFieldsChange={onFieldsChange}
                fieldList={fieldList}
                itemsList={itemsList}
                frontendHintText={frontendHintText}
              />
            </Skeleton>
          </div>
          <div className={Style.mask} />
        </div>

        <div className={Style.maskWrapper} onFocusCapture={blockFocus}>
          <div className={Style.box}>
            <Divider style={{ margin: '0' }} />
            <AptitudeAttach
              dataSource={qualDocFileList}
              onChange={onChangeAptitude}
              productCode={productCode}
              loading={loadingPage}
            />
          </div>
          <div className={Style.mask} />
        </div>

        {/* 外部链接/价格佐证 只读 */}
        <div className={Style.maskWrapper} onFocusCapture={blockFocus}>
          <div className={Style.box}>
            <div className={Style.boxtitle}>
              <span>外部链接/价格佐证</span>
            </div>
            <Divider style={{ margin: '0' }} />
            <Skeleton loading={loadingPage} active>
              <ExternalLink
                form={form}
                externalLinkList={externalLinkList}
                onLinkChange={handleLinkChange}
              />
            </Skeleton>
          </div>
          <div className={Style.mask} />
        </div>

        {/* 图文信息 只读 */}
        <div className={Style.maskWrapper} onFocusCapture={blockFocus}>
          <div className={Style.box}>
            <div className={Style.boxtitle}>
              <span>图文信息</span>
            </div>
            <Divider style={{ margin: '0' }} />
            <Skeleton loading={loadingPage} active>
              <div className={Style.picinfobox}>
                {/* true 显示 匹配、类似 注意必填校验 */}
                <Mainpic required form={form} onFieldsChange={onFieldsChange} />
                <div className={Style.picinfotitle}>
                  <span className={Style.text}>
                    主图：
                    <span
                      style={{
                        color: '#8C8C8C',
                        fontSize: '12px',
                        lineHeight: '24px',
                      }}
                    >
                      尺寸：800×800 px。建议上传3张及以上，最多20张。第一张白底，其它尽量白底。主图要求颜色唯一，需要与描述或者拓展属性值一致【最低标准∶不低于在其他平台上架的标准】
                    </span>
                  </span>
                </div>
                {preCheckErrors?.picturesError && (
                  <div
                    style={{
                      color: '#FF7D00',
                      fontSize: '14px',
                      lineHeight: '24px',
                    }}
                  >
                    {preCheckErrors?.picturesError}
                  </div>
                )}
                <Uploadimg
                  dataSource={pictures}
                  onChange={onChangePic}
                  disable
                />
                <div hidden>
                  <Originalpic
                    required={false}
                    form={form}
                    onFieldsChange={onFieldsChange}
                  />
                </div>
                <div className={Style.picinfotitle}>
                  <span className={Style.text}>
                    详情图：
                    <span
                      style={{
                        color: '#8C8C8C',
                        fontSize: '12px',
                        lineHeight: '24px',
                      }}
                    >
                      上传图片宽度不小于500 px，高度不限，最多100张。要图文丰富，需包含产品图、细节图、参数图、使用场景图，【最低标准:不低于在其他平台上架的标准】。一定不能包含:7天无理由退换货、送货上门、免费开票、水印、其它店铺信息、质保、包邮、链接、二维码、电话号码......等敏感词汇
                    </span>
                  </span>
                </div>
                {preCheckErrors?.detailsPicturesError && (
                  <div
                    style={{
                      color: '#FF7D00',
                      fontSize: '14px',
                      lineHeight: '24px',
                    }}
                  >
                    {preCheckErrors?.detailsPicturesError}
                  </div>
                )}
                <Uploadimg
                  dataSource={detailPic}
                  onChange={onChangeDetailPic}
                  disable
                />
              </div>
            </Skeleton>
          </div>
          <div className={Style.mask} />
        </div>
      </div>
      {/* 预审弹框 */}
      {PreCheckModalComponent}
    </Form.Provider>
  )
}

export default Goodsdetail

type MaterialDetailType =
  // 编辑
  | 'Edit'
  // 详情
  | 'Detail'
